module.exports = __webpack_public_path__ + "img/Icon_Instagram.d079afc1.svg";